import styled from "styled-components";
import { theme } from "@themes";

export const ContentHeader = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.neutral.white};
  color: ${({ theme }) => theme.text.primary};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  
  @media (max-width: 768px) {
    padding: 40px 20px;
    border-radius: 6px;
  }
`;

export const ContentLogo = styled.div`
  margin-bottom: 32px;
  
  img {
    width: 182px;
    height: 31.24px;
    
    @media (max-width: 768px) {
      width: 140px;
      height: auto;
    }
  }
`;

export const IllustrationContainer = styled.div`
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  
  img, svg {
    max-width: 300px;
    height: auto;
    
    @media (max-width: 768px) {
      max-width: 220px;
    }
  }
`;

export const ContentHomeAgent = styled.div``;

export const ContentText = styled.p`
  text-align: center;
  font-size: 18px;
  line-height: 1.2;
  color: ${({ theme }) => theme.text.primary};
  max-width: 720px;
  margin: 0 auto 12px;
  font-weight: 400;
  
  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 10px;
  }
`;

export const ContentTextBold = styled.p`
  text-align: center;
  font-size: 20px;
  line-height: 1.2;
  color: ${({ theme }) => theme.text.primary};
  max-width: 720px;
  margin: 0 auto 40px;
  font-weight: 700;
  
  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 30px;
  }
`;

export const ContentFooter = styled.div`
  width: 100%;
  min-height: 40vh;
  background-color: ${({ theme }) => theme.background.light};
  color: ${({ theme }) => theme.text.primary};
  display: grid;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 20px;
  
  @media (max-width: 768px) {
    padding: 30px 15px;
  }
`;

export const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 48px;
  flex-wrap: wrap;
  max-width: 900px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    gap: 32px;
  }
  
  @media (max-width: 576px) {
    gap: 24px;
  }
`;

export const ContentColHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
  
  &:hover {
    svg {
      transform: scale(1.15);
    }
    
    .MuiIcon-root {
      color: ${({ theme }) => theme.primary.purple};
      transform: scale(1.15);
    }
    
    label {
      color: ${({ theme }) => theme.primary.purple};
    }
  }
`;

export const ContentColFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 2em;
  padding-bottom: 50px;
  
  .MuiCircularProgress-colorPrimary {
    color: ${({ theme }) => theme.primary.purple};
  }

  .MuiCircularProgress-colorSecondary {
    color: ${({ theme }) => theme.neutral.gray[800]};
  }
`;

export const ContentIcon = styled.div`
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 40px;
    height: 40px;
    transition: all 0.2s ease;
  }
  
  .MuiIcon-root {
    font-size: 32px;
    color: ${({ theme }) => theme.neutral.iconGray};
    transition: all 0.2s ease;
  }
`;

export const ModulesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 18px;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
